import { render, staticRenderFns } from "./VMyTravels.vue?vue&type=template&id=4e0b968a&"
import script from "./VMyTravels.vue?vue&type=script&lang=js&"
export * from "./VMyTravels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports